import { createWatcher, WatcherType } from 'rewire-core';
import { ICell, IGrid, IRowData }     from 'rewire-grid';

export default class SelectedCellWatcher {
  _watch:           WatcherType<IGrid>;
  lastSelectedCell: ICell;

  constructor() {
    this._watch = createWatcher();
  }

  watch(grid: IGrid, rows: IRowData[], callback: (cell?: any) => void) {
    const myCallback = () => {
      const cell = grid.selectedCells[0];
      if (cell === this.lastSelectedCell) return;

      this.lastSelectedCell = cell;

      if (cell?.row?.id) {
        const foundRow  = grid.rows.find(r => r.id === cell.row.id);
        const foundCell = foundRow ? Object.values(foundRow.cells).find(c => c.column.name === this.lastSelectedCell.column.name) : null;
        callback(foundCell);
      } else {
        callback(undefined);
      }
    };
    this._watch(grid, ['selectedCells'], myCallback);
  }

  unwatch() {
    this._watch();
  }
}
